export const getLocationSubparts = (location: Location): string[] => {
  const locationSubparts = location.pathname
    .split("/")
    .filter((subpart) => subpart.length > 0 && !subpart.match(/\d+/g));

  return locationSubparts;
};
